export default __webpack_public_path__ + "static/media/12b05c7d-5602-47ed-8f89-47b92722b11a.7f819a8e.JPG";